import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = '', ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, as: Tag = 'h1', className = '', lineClassName = '', baseDelay = 0.15 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span className="reveal-line" key={i}>
        <motion.span
          className={lineClassName}
          initial={{ y: '110%' }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: baseDelay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-mono text-xs font-bold uppercase tracking-[0.25em] ${light ? 'text-sky-300' : 'text-brand'}`}>
    {children}
  </p>
);

export const Chapter = ({ num, label, light = false }) => (
  <div className="flex items-center gap-3">
    <span className={`font-mono text-sm font-bold ${light ? 'text-sky-300' : 'text-brand'}`}>{num}</span>
    <span className={`h-px w-10 ${light ? 'bg-sky-300/40' : 'bg-brand/40'}`} />
    <span className={`font-mono text-xs font-medium uppercase tracking-[0.25em] ${light ? 'text-slate-300' : 'text-slate-500'}`}>{label}</span>
  </div>
);
